import { render, staticRenderFns } from "./AddPatientDialog.vue?vue&type=template&id=32a3ac6b&"
import script from "./AddPatientDialog.vue?vue&type=script&lang=js&"
export * from "./AddPatientDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddPatientDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports